import { BaseApiService } from "api/BaseApiService";
import { sanitizeODateFilterValue } from "../../../common/helpers/sanitazeODateFilterValue";

class CmsRepository extends BaseApiService {
  constructor() {
    super("media");
  }

  fetchAllSections = async (name?: string) => {
    const sanitizedName = name ? encodeURIComponent(sanitizeODateFilterValue(name)) : "";

    const res = await this.get(
      `odata/Cms?includeDeleted=false&api-version=1.0&$count=true${
        name ? `&$filter=contains(tolower(Title), tolower('${sanitizedName}'))` : ""
      }&$orderby=Title asc`
    );

    return res.value;
  };

  fetchByFilter = async (type: string) => {
    const res = await this.get(`odata/Cms?$filter=Type eq '${type}'`);

    return res.value[0];
  };

  uploadImage = async (file: File) => {
    const formData = new FormData();
    formData.append("formFile", file);

    return await this.post("ImageCms/Add", formData, {
      headers: {},
    }).catch(() => file.name);
  };

  publish = async (partner: { type: string; jsonData: string; link: string; title: string; isSiteShow: boolean }) =>
    await this.post("Cms/Save", JSON.stringify(partner));
}

export const cmsRepository = new CmsRepository();
